export default __webpack_public_path__ + "static/karcz-f5f3213277074cb39cb906c3156c961a.jpg";